export abstract class BaseModel {}
